<template>
  <BApp>
    <BNavbar
        v-if="!$route.meta.hideHeader"
        class="px-3 d-flex align-items-center navbar-bg"
    >
      <BButton
          variant="light"
          class="rounded-3 shadow-sm"
          @click="toggleMenu"
      >
        ☰
      </BButton>

      <button
          type="button"
          class="navbar-logo-button"
          @click="goHome"
          aria-label="Ir para a tela inicial"
      >
        <img src="@/assets/onbet.png" alt="" aria-hidden="true" />
      </button>

      <BDropdown
          end
          no-caret
          variant="light"
          class="ms-auto"
          toggle-class="rounded-3 px-3 py-2 shadow-sm d-inline-flex align-items-center justify-content-center"
          menu-class="shadow border-0 rounded-3"
      >
        <template #button-content>
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 16 16"
              aria-hidden="true"
          >
            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
            <path
                d="M8 9a6 6 0 0 0-6 6 .5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5 6 6 0 0 0-6-6z"
            />
          </svg>
        </template>

        <BDropdownItem @click="goToMyAccount">
          Minha conta
        </BDropdownItem>

        <BDropdownDivider />

        <BDropdownItem class="text-danger" @click="handleLogout">
          Sair
        </BDropdownItem>
      </BDropdown>
    </BNavbar>

    <BOffcanvas
        v-if="!$route.meta.hideHeader"
        v-model="menuOpen"
        placement="start"
        title="Menu"
    >
      <BNav vertical>
        <BNavItem to="/home" @click="menuOpen = false">
          Home
        </BNavItem>

        <BNavItem to="/avisos" @click="menuOpen = false">
          Avisos
        </BNavItem>

        <BNavItem
            v-if="canSeeRestrictedMenu()"
            to="/investidores"
            @click="menuOpen = false"
        >
          Investidores
        </BNavItem>

        <BNavItem
            to="/investimentos-disponiveis"
            @click="menuOpen = false"
        >
          Investimentos
        </BNavItem>

        <BNavItem
            v-if="canSeeRestrictedMenu()"
            to="/investimentos"
            @click="menuOpen = false"
        >
          Gerenciar Investimentos
        </BNavItem>

        <BNavItem
            @click="myDeposits()"
        >
          Meus Depositos
        </BNavItem>

        <BNavItem
            v-if="canSeeRestrictedMenu()"
            to="/depositos/todos"
            @click="menuOpen = false"
        >
          Todos os Depósitos
        </BNavItem>

        <BNavItem
            to="/devolucoes"
            @click="menuOpen = false"
        >
          Devoluções
        </BNavItem>

        <BNavItem
            to="/historico-pagamentos"
            @click="menuOpen = false"
        >
          Histórico de Pagamentos
        </BNavItem>

        <BNavItem
            v-if="canSeeRestrictedMenu()"
            @click="goToLoginMetrics()"
        >
          Métricas de Login
        </BNavItem>

        <BNavItem
            @click="myWallet()"
        >
          Minha Carteira
        </BNavItem>

      </BNav>
    </BOffcanvas>

    <BContainer
        fluid
        :class="$route.meta.hideHeader ? 'p-0' : 'content-container p-4'"
    >
      <router-view :key="router.fullPath" />
    </BContainer>
  </BApp>
</template>

<script setup>
import { ref, nextTick } from "vue"
import { useRouter } from "vue-router"
import {
  BApp,
  BNavbar,
  BButton,
  BOffcanvas,
  BNav,
  BNavItem,
  BContainer,
  BDropdown,
  BDropdownItem,
  BDropdownDivider
} from "bootstrap-vue-next"
import { getInvestorId, getRole, logout } from "@/service/authService"

const menuOpen = ref(false)
const router = useRouter()

const toggleMenu = () => {
  menuOpen.value = !menuOpen.value
}

const canSeeRestrictedMenu = () => {
  const role = (getRole() || "").toLowerCase()
  return role === "admin" || role === "employee"
}

const myDeposits = async () => {
  const investorId = getInvestorId()

  if (!investorId) return

  // Fechar menu ANTES de navegar
  menuOpen.value = false

  // Aguardar o DOM ser atualizado
  await nextTick()

  try {
    await router.push({
      path: `/depositos/${investorId}`
    })
  } catch (error) {
    console.error("Erro ao navegar:", error)
  }
}

const myWallet = async () => {
  const investorId = getInvestorId()

  if (!investorId) return

  menuOpen.value = false
  await nextTick()

  try {
    await router.push({
      name: 'wallet',
      params: { investorId }
    })
  } catch (error) {
    console.error("Erro ao navegar:", error)
  }
}

const buildCurrentYearRange = () => {
  const currentYear = new Date().getFullYear()
  return {
    start: `${currentYear}-01-01`,
    end: `${currentYear}-12-31`
  }
}

const LOGIN_METRICS_FIXED_USER_ID = 'c8a60158-cabe-4c48-a0b6-d3a1667c82ea'

const goToLoginMetrics = async () => {
  const userId = LOGIN_METRICS_FIXED_USER_ID
  const { start, end } = buildCurrentYearRange()

  menuOpen.value = false
  await nextTick()

  await router.push({
    path: `/metricas-login/${encodeURIComponent(userId)}/${encodeURIComponent(start)}/${encodeURIComponent(end)}`
  })
}

const goToMyAccount = async () => {
  const investorId = getInvestorId()

  if (!investorId) return

  await router.push({
    name: "investor-edit",
    params: { id: investorId }
  })
}

const goHome = async () => {
  if (router.currentRoute.value.path === "/home") return

  await router.push("/home")
}

const handleLogout = async () => {
  logout()
  await router.push("/")
}
</script>

<style scoped>
.navbar-bg {
  background-image: url("@/assets/onbet.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 100px;
  position: relative;
}

.navbar-logo-button {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  width: 180px;
  height: 70px;

  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  z-index: 1;
}

.navbar-logo-button img {
  display: none;
}

.navbar-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.28);
}

.navbar-bg > * {
  position: relative;
  z-index: 1;
}

.content-container {
  min-height: calc(100vh - 100px);
}

@media (max-width: 768px) {

  .navbar-bg {
    height: 70px;
  }

  .content-container {
    min-height: calc(100vh - 70px);
  }

  .navbar-logo-button {
    width: 110px;
    height: 45px;
  }

  .navbar-logo-button img {
    height: 70px;
  }
}
</style>